import Layout from "../../components/mainPage/Layout";
import DispatcherSimulator from "../../images/systemComponents/DispatcherSimulator.png";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1 className="mb-4 ">
                    Тренажер диспетчера
                </h1>
                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        <b>Тренажер диспетчера (Dispatcher Training Simulator, DTS)</b>, интегрированный со SCADA NPT Expert и основанный на стандарте CIM (Common Information Model), является продвинутым инструментом для обучения и подготовки диспетчерского персонала в электроэнергетике. Он позволяет моделировать различные сценарии работы энергосистемы, что помогает диспетчерам отрабатывать навыки управления сетью в нормальных и аварийных условиях.
                    </p>
                    <img
                        src={DispatcherSimulator}
                        className="mb-4  w-100"
                        alt="Тренажер диспетчера"
                    />

                    <p>Основные задачи, которые он позволяет решать, включают:</p>

                    <ul className="mb-4 description__list">

                        <li className="mb-1 description__number-li"><b>Обучение персонала на реальных данных</b>
                            <ul>
                                <li>Создание реалистичных учебных сценариев с использование данных SCADA NPT Expert.                            </li>
                                <li>Имитация работы энергосистемы на основе текущих или исторических данных.</li>
                            </ul>
                        </li>

                        <li className="mb-1 description__number-li"><b>Обучение и подготовка диспетчерского персонала</b>
                            <ul>
                                <li>Обучение и подготовка к работе со SCADA NPT Expert. </li>
                                <li>Отработка навыков управления энергосистемой с имитацией реальных условий.</li>
                                <li>Отработка взаимодействия между диспетчерами разных уровней (например, системный и региональный диспетчеры).</li>
                                <li>Подготовка к действиям в нештатных и аварийных ситуациях.</li>
                                <li>Отработка навыков анализа состояния сети и прогнозирования ее поведения.</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Моделирование аварийных ситуаций</b>
                            <ul>
                                <li>Создание сценариев коротких замыканий, отключений линий, генераторов или трансформаторов.</li>
                                <li>Отработка действий по ликвидации аварий и восстановлению нормального режима работы сети.</li>
                                <li>Анализ последствий аварий и обучение персонала действиям по их предотвращению.</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Отработка навыков управления режимами работы энергосистемы</b>
                            <ul>
                                <li>Управление нагрузкой и генерацией в различных режимах работы сети.</li>
                                <li>Отработка переключений в сети (включение/отключение оборудования, перераспределение потоков мощности).</li>
                                <li>Обучение работе с устройствами релейной защиты и автоматики (РЗА).</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li"><b>Проверка и оптимизация решений</b>
                            <ul>
                                <li>Тестирование новых алгоритмов управления энергосистемой.</li>
                                <li>Оценка эффективности предлагаемых решений до их внедрения в реальную сеть.</li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </Layout>
}